import styled from "styled-components";

const color = {
  refrigerated: `#2a3341`,
  roomTemperature: `#FFE072`,
  carrier: `#cdb5f5`,
};

export const Container = styled.div`
  /* @font-face {
    font-family: "JSArirangHON-Regular";
    src: url("https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/JSArirangHON-RegularA1.woff")
      format("woff");
    font-weight: normal;
    font-style: normal;
  } */
  width: 100vw;
  min-height: 100vh;
  cursor: url("/img/kiosk_cursor_hover.png") 0 0, auto;
  button,
  a,
  input,
  label,
  textarea,
  select,
  body {
    cursor: url("/img/kiosk_cursor_hover.png") 0 0, auto;
  }
  position: relative;
  &.bg {
    background: #1e1e1e;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 4.9444vw;
  z-index: 100;
  button {
    background: transparent;
    border: none;
    display: flex;
    color: #ccc;
  }
`;

export const Header = styled.header`
  @font-face {
    font-family: "JSArirangHON-Regular";
    src: url("https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/JSArirangHON-RegularA1.woff")
      format("woff");
    font-weight: normal;
    font-style: normal;
  }
  color: #333;
  position: relative;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  &.sungsim {
    font-family: "JSArirangHON-Regular", sans-serif;
    .tit {
      svg {
        margin: 5px auto 0;
      }
    }
  }
  &.baseball {
    font-weight: 800;
  }
  .tit {
    font-size: 50px;
    display: flex;
    align-items: center;
    gap: 20px;
    .operation {
      display: flex;
      align-items: center;
      flex-direction: column;
      border: none;
      background: transparent;
      justify-content: center;
      color: #2a3341;
      svg {
        display: block;
      }
    }
  }
  .searchForm {
    width: 400px;
    height: 50px;
    position: relative;
    color: #4d4d4d;
    border-bottom: 3px solid #a0a0a0;
    display: flex;
    align-items: center;
    font-size: 18px;
    input {
      display: block;
      width: calc(100% - 130px);
      height: 100%;
      border: none;
      font-weight: 700;
      &:focus {
        border: none !important;
        border-bottom: none;
        box-shadow: none;
      }
    }
    .reset {
      width: 24px;
      height: 24px;
      border: none;
      background: transparent;
      background: #eee;
      border-radius: 50%;
      svg {
        display: block;
        margin: auto;
      }
    }
    .search {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background: rgb(42, 51, 65);
      color: rgb(255, 255, 255);
      border: none;
      border-radius: 31px;
      width: 100px;
      height: 40px;
    }
  }
  .date {
    position: relative;
    font-size: 18px;
    > button {
      width: 100px;
      height: 40px;
      background: rgb(42, 51, 65);
      color: rgb(255, 255, 255);
      border: none;
      border-radius: 31px;
    }
    .bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 900;
    }
    .calendarContent {
      position: relative;
      .reset {
        height: 50px;
        position: absolute;
        top: 10px;
        left: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          font-weight: 700;
          background: rgb(42, 51, 65);
          color: rgb(255, 255, 255);
          border-radius: 10px;
          padding: 2px 10px;
          border: none;
        }
      }
    }
    .calendar {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
      width: min-content;
      height: min-content;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      border-radius: 10px;
      overflow: hidden;
      .rdrDefinedRangesWrapper,
      .rdrDateDisplayWrapper {
        display: none;
      }
      .rdrDateRangeWrapper {
        font-size: 20px;
        font-weight: 700;
      }
      .rdrDateDisplayItem input,
      .rdrMonthAndYearPickers select,
      .rdrWeekDay,
      .rdrDay button {
        font-weight: 700;
      }
    }
  }
  .close {
    display: flex;
    gap: 10px;
    font-size: 50px;
    button {
      border: none;
      background: transparent;
      color: #333;
      display: flex;
      svg {
        stroke-width: 10px;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    flex-wrap: wrap;
    .searchForm .search,
    .date > button {
      font-size: 18px;
      width: 90px;
      height: 40px;
    }
    .tit {
      width: 100%;
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
    }
    .date {
      order: 3;
      margin-right: 10px;
    }
    .searchForm {
      height: 55px;
      order: 4;
      min-width: 100px;
      flex: 1;
    }
  }
  @media screen and (max-width: 767px) {
    .tit,
    .close {
      font-size: 30px;
    }
    .searchForm .search,
    .date > button {
      font-size: 14px;
      width: 70px;
      height: 30px;
    }
    .searchForm {
      height: 40px;
    }
    .date .calendar {
      max-width: 90%;
      .reset {
        position: relative;
        display: block;
        height: auto;
        text-align: right;
        top: 0;
        left: 0;
        padding: 10px 10px 0;
        button {
          font-weight: normal;
          font-size: 14px;
        }
      }
      .rdrDateRangeWrapper {
        font-size: 12px;
      }
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 700;
  font-size: 50px;
  &.baseball {
    justify-content: end;
  }
  &.sungsim {
    gap: 40px;
    justify-content: space-between;
  }
  .kioskLogo {
    flex: 1;
    text-align: right;
    img {
      max-width: 100%;
      height: 100%;
      max-height: 80px;
      object-fit: contain;
    }
  }
  @media screen and (max-width: 1050px) {
    font-size: 40px;
  }
  @media screen and (max-width: 767px) {
    font-size: 22px;
    &.sungsim {
      gap: 0;
      justify-content: end;
      .kioskLogo {
        display: none;
      }
    }
  }
`;

export const Table = styled.ul`
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  overflow-y: auto;
  overflow-x: hidden;
  &.pickup {
    height: 49%;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
  }
  li {
    text-align: center;
    font-size: 16px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid #f2f2f2;
    &.notUser {
      width: 100%;
      height: calc(100% - 70px);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:first-child {
      font-weight: 700;
      background: #f2f2f2;
    }
    &:not(:first-child) .status span {
      font-size: 14px;
      border: 2px solid;
      padding: 2px 7px;
      font-weight: 700;
    }
    .tel,
    .duration,
    .memo,
    .time,
    .price,
    .moblphonNo,
    .createdAt {
      width: 15%;
    }
    .status,
    .type,
    .name,
    .index,
    .payType,
    .platform,
    .stamps,
    .rewardCount,
    .regionNo,
    .rewardAvailable {
      width: 10%;
    }
    .actions {
      width: 10%;
      button {
        background: #efefef;
        border: 2px solid #efefef;
        border: none;
        padding: 5px 0;
        font-weight: 700;
        width: 100%;
        border-radius: 3px;
      }
    }
  }
`;

export const List = styled.ul`
  gap: 5px;
  font-size: 18px;
  &.pickUp {
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
  }
  > li {
    display: inline-block;
    width: calc(50% - 2.5px);
    padding: 10px;
    border: 3px solid #efefef;
    border-radius: 20px;
    position: relative;
    &:not(.notUser) {
      max-height: 300px;
      height: min-content;
      &:nth-child(2n + 2) {
        margin-bottom: 5px;
      }
      &:nth-child(odd) {
        margin-right: 5px;
      }
    }
    &.notUser {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    ul {
      li {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 7px;
        &:last-child {
          margin-bottom: 0;
        }
        span.tit {
          font-weight: 700;
        }
        span.status {
          background: #fff;
          color: #2e5aac;
          border: 2px solid #2e5aac;
          padding: 2px 7px;
          font-weight: 700;
          font-size: 12px;
        }
        &.storageCategory {
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 30px;
            gap: 10px;
            .box {
              height: 30px;
              width: 30px;
              border-radius: 50%;
              background-repeat: no-repeat;
              background-position: 50% 50%;
              background-size: 60%;
              &.refrigerated {
                background-color: ${color.refrigerated};
                background-image: url("/img/sungsimdang/sungsimdang_refrigerated_storage.png");
              }
              &.roomTemperature {
                background-color: ${color.roomTemperature};
                background-image: url("/img/sungsimdang/sungsimdang_roomTemperature_storage.png");
              }
              &.carrier {
                background-color: ${color.carrier};
                background-image: url("/img/sungsimdang/sungsimdang_carrier_storage.png");
              }
            }
          }
        }
      }
    }
    .statusButton {
      position: absolute;
      top: 10px;
      right: 10px;
      background: #efefef;
      border-radius: 5px;
      border: none;
      padding: 5px 10px;
      font-weight: 700;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    > li {
      width: 100%;
      &:not(.notUser) {
        max-height: none;
        margin-bottom: 5px;
        &:nth-child(odd) {
          margin-right: 0;
        }
      }
    }
  }
`;

export const CustomInput = styled.label`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  height: 35px;
  width: 35px;
  &.block {
    display: block;
    /* margin: auto; */
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    padding: 0;
    width: 0;
    height: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border: 2px solid ${color.refrigerated};
    border-radius: 10px;
    background-color: transparent;
    transition: all 0.3s ease;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg) scale(0);
      opacity: 0;
      width: 13px;
      height: 24px;
      border: solid #fff;
      border-width: 0px 3px 3px 0px;
      transition: 0.3s;
    }
  }
  input:checked ~ .checkmark {
    background: ${color.refrigerated};
    &:after {
      opacity: 1;
      transform: translate(-50%, -65%) rotate(45deg) scale(1);
      border-color: #fff;
    }
  }
  &:hover .checkmark {
    background-color: #efefef;
  }
  @media screen and (max-width: 767px) {
    width: 25px;
    height: 25px;
    .checkmark {
      border-radius: 5px;
    }
    .checkmark::after {
      width: 9px;
      height: 15px;
    }
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  display: flex;
  font-size: 50px;
  z-index: 3333;
  @media screen and (max-width: 767px) {
    font-size: 30px;
    top: 5px;
    right: 5px;
  }
`;

export const Modal = styled.div`
  position: absolute;
  max-width: 900px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border: 1px solid #a6a6a6;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  font-size: 40px;
  border-radius: 30px;
  box-sizing: border-box;
  font-weight: 700;
  overflow: hidden;
  width: 100%;
  height: 700px;
  z-index: 33;
  &.cust {
    max-width: 1000px;
  }
  .modalContent {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 50px;
  }
  @media screen and (max-width: 767px) {
    width: 90%;
    height: 90%;
    max-width: none;
    font-size: 20px;
    border-radius: 15px;
    .modalContent {
      padding: 15px;
    }
  }
`;

export const Buttons = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 30px;
  button {
    width: 200px;
    border: none;
    padding: 10px 0;
    border-radius: 10px;
    background: ${color.refrigerated};
    transition: 0.3s;
    color: #fff;
    &:first-child {
      margin-right: 20px;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    font-size: 20px;
    button {
      width: calc(50% - 10px);
    }
  }
`;
